var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 11.5833C5.66667 11.4286 5.72812 11.2803 5.83752 11.1709C5.94692 11.0615 6.09529 11 6.25 11H9.75C9.90471 11 10.0531 11.0615 10.1625 11.1709C10.2719 11.2803 10.3333 11.4286 10.3333 11.5833C10.3333 11.738 10.2719 11.8864 10.1625 11.9958C10.0531 12.1052 9.90471 12.1667 9.75 12.1667H6.25C6.09529 12.1667 5.94692 12.1052 5.83752 11.9958C5.72812 11.8864 5.66667 11.738 5.66667 11.5833ZM3.33333 8.08333C3.33333 7.92862 3.39479 7.78025 3.50419 7.67085C3.61358 7.56146 3.76196 7.5 3.91667 7.5H12.0833C12.238 7.5 12.3864 7.56146 12.4958 7.67085C12.6052 7.78025 12.6667 7.92862 12.6667 8.08333C12.6667 8.23804 12.6052 8.38642 12.4958 8.49581C12.3864 8.60521 12.238 8.66667 12.0833 8.66667H3.91667C3.76196 8.66667 3.61358 8.60521 3.50419 8.49581C3.39479 8.38642 3.33333 8.23804 3.33333 8.08333ZM1 4.58333C1 4.42862 1.06146 4.28025 1.17085 4.17085C1.28025 4.06146 1.42862 4 1.58333 4H14.4167C14.5714 4 14.7197 4.06146 14.8291 4.17085C14.9385 4.28025 15 4.42862 15 4.58333C15 4.73804 14.9385 4.88642 14.8291 4.99581C14.7197 5.10521 14.5714 5.16667 14.4167 5.16667H1.58333C1.42862 5.16667 1.28025 5.10521 1.17085 4.99581C1.06146 4.88642 1 4.73804 1 4.58333Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilter);
export default __webpack_public_path__ + "static/media/table-filter.7b7dc612f9a11280f115d260d1606ab7.svg";
export { ForwardRef as ReactComponent };